module.exports = __webpack_public_path__ + "static/media/favicon-ms624.b8c93ae8.ico";